import { SB } from '@play-co/replicant';

const promoGroupItemSchema = SB.object({
  /** Timestamp when this item was last shown */
  shownAt: SB.int().default(0),
  /** Total number of times this item has been shown */
  count: SB.int().default(0),
  /** Event ID of the last shown event instance (for recurring items) */
  lastShownEventId: SB.string().default(''),
});

const promoGroupSchema = SB.object({
  /** Per-item state tracking */
  items: SB.map(promoGroupItemSchema),
});

export default {
  promoGroups: SB.map(promoGroupSchema),
};
